import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { SiteDataCaptureSites } from "../interfaces/siteType";
import { GetSDCaptureBySiteIdAndDateResponse, GetSiteDataCaptureDigestersResponse, GetSiteDigestersDataByGeneralIdResponse, SaveSDCaptureRequest, SaveSiteDataCaptureRequest, SDCEquipmentItem, SDEquipmentCategory, SDEquipmentLookup, SiteDigesterGeneralDataResponse, SiteDownTimeResponse } from "../interfaces/sdcmodel";
import { IdName } from "../interfaces/pricematrixmodel";

@Injectable({
    providedIn: 'root'
  })
  export class SiteDataService {
    baseUrl = environment.baseUrl +'sitedatacapture/';
    constructor(private http: HttpClient) { }      
      
    getsdcSites():Observable<SiteDataCaptureSites[]> {
        var url = `${this.baseUrl}GetSiteDataCaptureSites`;
        return this.http.get<SiteDataCaptureSites[]>(url);
    }
      
    getsdcData(siteId:string | null, fromDate: string | null, toDate: string | null):Observable<SiteDigesterGeneralDataResponse[]> {
        var url = `${this.baseUrl}GetSiteDigesterGeneralData?sid=${siteId}&FromDate=${fromDate}&ToDate=${toDate}`;
        if(siteId === null){
            url = `${this.baseUrl}GetSiteDigesterGeneralData?sid=&FromDate=${fromDate}&ToDate=${toDate}`;
        }
        return this.http.get<SiteDigesterGeneralDataResponse[]>(url);
    }

    getsdtData(siteId: number | null, fromDate: string | null, toDate: string | null): Observable<SiteDownTimeResponse[]> {
        const params = new HttpParams()
            .set('sid', siteId?.toString() ?? '')
            .set('FromDate', fromDate ?? '')
            .set('ToDate', toDate ?? '');
        const url = `${this.baseUrl}GetSDCapture`;
        return this.http.get<SiteDownTimeResponse[]>(url, { params });
    }
    getSDCaptureBySiteIdAndDate(siteId: number, dateCaptured: string): Observable<GetSDCaptureBySiteIdAndDateResponse[]> {
        const params = new HttpParams()
            .set('SiteId', siteId.toString())
            .set('DateCaptured', dateCaptured);
        const url = `${this.baseUrl}GetSDCaptureBySiteIdAndDate`;
        return this.http.get<GetSDCaptureBySiteIdAndDateResponse[]>(url, { params });
    }
    getSiteDowntimeTriggerId(downtimeMinutes: number, impactId: number, equipmentId: number): Observable<number> {
        const params = new HttpParams()
            .set('downtimeMinutes', downtimeMinutes.toString())
            .set('impactId', impactId.toString())
            .set('equipmentId', equipmentId.toString());
        const url = `${this.baseUrl}GetSiteDowntimeTriggerId`;
        return this.http.get<number>(url, { params });
    }
    deleteSDCaptureBySiteIdAndDate(siteId: number, dateCaptured: string): Observable<boolean> {
        const params = new HttpParams()
            .set('SiteId', siteId.toString())
            .set('DateCaptured', dateCaptured);
        const url = `${this.baseUrl}DeleteSDCaptureBySiteIdAndDate`;
        return this.http.delete<boolean>(url, { params });
    }
    getSDEquipmentCategories(): Observable<SDEquipmentCategory[]> {
        const url = `${environment.baseUrl}masters/GetSDEquipmentCategory`;
        return this.http.get<SDEquipmentCategory[]>(url);
    }

    getSDEquipmentLookup(categoryId: number): Observable<SDEquipmentLookup[]> {
        const url = `${environment.baseUrl}masters/GetSDEquipmentLookup?categoryId=${categoryId}`;
        return this.http.get<SDEquipmentLookup[]>(url);
    }
    getsdcEquipData():Observable<SDCEquipmentItem[]> {
        var url = `${this.baseUrl}GetSDCEquipmentValues`;
        return this.http.get<SDCEquipmentItem[]>(url);
    }

    getImpactTypes(): Observable<IdName[]> {
        const url = `${environment.baseUrl}masters/GetSDImpactLookup`;
        return this.http.get<IdName[]>(url);
    }
    getsdcDynTabs(siteId:string | null, dateCapture: string):Observable<GetSiteDataCaptureDigestersResponse[]> {
        var url = `${this.baseUrl}GetSiteDataCaptureDigesters?sid=${siteId}&dateCaptured=${dateCapture}`;
        return this.http.get<GetSiteDataCaptureDigestersResponse[]>(url);
    }
      
    getsdcDataById(id: number):Observable<SiteDigesterGeneralDataResponse> {
        var url = `${this.baseUrl}GetSiteDigesterGeneralData?id=${id}`;
        return this.http.get<SiteDigesterGeneralDataResponse>(url);
    }
      
    getsdcTabsDataById(id: number):Observable<GetSiteDigestersDataByGeneralIdResponse> {
        var url = `${this.baseUrl}GetSiteDigestersDataByGeneralId?id=${id}`;
        return this.http.get<GetSiteDigestersDataByGeneralIdResponse>(url);
    }

    saveSDCData(payload: SaveSiteDataCaptureRequest): Observable<boolean> {
        const saveApiUrl = environment.baseUrl +'sitedatacapture?DateCaptured='+payload.siteDigesterGeneralData.dateCaptured;
        return this.http.post<boolean>(saveApiUrl, payload);
    }
    
    saveSDTData(payload: SaveSDCaptureRequest): Observable<boolean> {
        const saveApiUrl = environment.baseUrl +'sitedatacapture/SaveSDCapture';
        return this.http.post<boolean>(saveApiUrl, payload);
    }

    deletesiteDataCaptureData(id: number): Observable<boolean> {
      const params = new HttpParams().set('id', id.toString());
      var url = `${this.baseUrl}DeleteSiteDigesterData`;
      return this.http.delete<boolean>(`${url}`, { params: params });
    }
  }
